import { VideoSoundControl } from "./VideoSoundControl";

export class VideoManager {
  videoObserver!: IntersectionObserver;

  constructor() {
    this.setupAutoplayVideos();
    this.setupNonAutoplayVideos();
  }

  setupAutoplayVideos() {

    // Pause autoplay videos when out of view
    const autoplayVideos = Array.from(document.querySelectorAll('video[autoplay]')) as HTMLVideoElement[];

    const allAutoplayVideos = [...autoplayVideos];

    if (allAutoplayVideos.length === 0) {
      return;
    }

    this.videoObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target as HTMLVideoElement;
        if (entry.isIntersecting) {
          video.play();
        } else {
          video.pause();
        }
      });
    });

    allAutoplayVideos.forEach(video => {
      this.videoObserver.observe(video);
      new VideoSoundControl(video);
    });
  }

  setupNonAutoplayVideos() {
    const nonAutoplayVideos = Array.from(document.querySelectorAll('video:not([autoplay])')) as HTMLVideoElement[];

    const nonAutoplayVideosWithoutControls = nonAutoplayVideos.filter(video => !video.hasAttribute('controls'));

    if (nonAutoplayVideosWithoutControls.length === 0) {
      return;
    }

    nonAutoplayVideos.forEach((video: HTMLVideoElement) => {
      this.addPlayButtonIcon(video);
      const parentBlock = video.closest('.wp-block-video') as HTMLElement;

      parentBlock.addEventListener('click', () => {
        if (!parentBlock.classList.contains('is-active')) {
          return;
        }

        if (video.paused) {
          video.play();
          parentBlock.classList.add('is-playing');
        } else {
          video.pause();
          parentBlock.classList.remove('is-playing');
        }
      });
    });
  }

  addPlayButtonIcon(video: HTMLVideoElement): void {
    const parentBlock = video.closest('.wp-block-video');

    if (parentBlock) {
      parentBlock.classList.add('has-play-button');

      const playButton = document.createElement('button');
      playButton.classList.add('btn-play');
      playButton.setAttribute('aria-label', 'Play video');

      // Click handler
      playButton.addEventListener('click', (event) => {
        if (parentBlock.classList.contains('is-active')) {
          return;
        }

        event.stopPropagation();
        event.preventDefault();
        video.play();
        parentBlock.classList.add('is-active', 'is-playing');
        this.videoObserver.observe(video);
      });

      playButton.addEventListener('mouseenter', () => {
        parentBlock.classList.add('is-hovered');
      });

      playButton.addEventListener('mouseleave', () => {
        parentBlock.classList.remove('is-hovered');
      });

      playButton.innerHTML = `
<svg viewBox="0 0 125 138" fill="none" xmlns="http://www.w3.org/2000/svg" class="fill-current">
<path d="M7.61942 136.016C5.28134 134.688 3.34354 132.771 2.00472 130.462C0.665918 128.153 -0.0257242 125.534 0.00074231 122.874L0.00074702 15.1194C-0.0257192 12.4597 0.665924 9.84098 2.00473 7.5317C3.34354 5.22241 5.28135 3.30569 7.61943 1.97811C9.86868 0.682681 12.4268 -4.92073e-06 15.0319 -4.80686e-06C17.6369 -4.69299e-06 20.195 0.682681 22.4443 1.97811L117.362 55.8433C119.688 57.1896 121.616 59.1117 122.955 61.4189C124.295 63.7261 125 66.3384 125 68.9969C125 71.6554 124.295 74.2677 122.955 76.5749C121.616 78.8821 119.688 80.8042 117.362 82.1505L22.4443 136.028C20.1939 137.322 17.6352 138.002 15.0302 138C12.4251 137.998 9.86756 137.313 7.61942 136.016Z" />
</svg>`;

      parentBlock.appendChild(playButton);
    }
  }
}
